module.exports = __webpack_public_path__ + "static/media/got-chest.ecf0fda5.mp3";